// extracted by mini-css-extract-plugin
export var chevron = "_f1-2";
export var dropdownItems = "_f1-0";
export var item = "_f1-1";